import { useDeletePatientReportMutation } from '../api';

export const useDeletePatientReportUseCase = () => {
  const [deleteReport, { isLoading, isSuccess, data, error }] = useDeletePatientReportMutation();

  return { deleteReport, data, isLoading, isSuccess, error };
};
